import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageAssetDelete
{
    constructor(targetElement)
    {
        // targetEl, fileUrl)
        const fileUrl = targetElement.dataset.fileurl;
        if (!fileUrl) return;

        const url = "assets/uses/count";

        const loadingEle = ele.byId("checkDelete");
        const errorEle = ele.byQuery("#problems .error");
        const containerEle = ele.byId("problems");
        const deleteContainer = ele.byId("deleteAsset");
        const deleteButton = ele.byId("deletebutton");

        api.post(url, { "filenames": [fileUrl] }, (response) =>
        {
            if (loadingEle) ele.hide(loadingEle);
            const count = response.data.countPatches || 0;
            const opCount = response.data.countOps || 0;
            if (count || opCount)
            {
                if (errorEle)
                {
                    const countEle = errorEle.querySelector(".countProjects");
                    const opCountEle = errorEle.querySelector(".countOps");
                    if (countEle) ele.hide(countEle);
                    if (opCountEle) ele.hide(opCountEle);

                    if (countEle && count)
                    {
                        countEle.querySelector(".count").innerText = count;
                        ele.show(countEle);
                    }
                    if (opCountEle && opCount)
                    {
                        opCountEle.querySelector(".count").innerText = opCount;
                        ele.show(opCountEle);
                    }
                    if (containerEle) ele.show(containerEle);
                }
                if (deleteButton)
                {
                    deleteButton.classList.remove("button-primary");
                    deleteButton.classList.add("button-delete");
                    deleteButton.innerText = "Delete anyhow";
                }
            }
            else
            {
                if (deleteContainer) ele.show(deleteContainer);
            }
        }, (e) =>
        {
            if (loadingEle) loadingEle.hide();
        });
    }

    deleteAsset(projectId, fileId)
    {
        const deleteButton = ele.byQuery("#deletebutton");
        const errorEle = ele.byQuery("#deleteAsset .error");

        web.buttons.startSavingAnimButton(deleteButton);
        api.delete(
            "project/" + projectId + "/file/" + fileId,
            (res) =>
            {
                document.location.reload();
            },
            (res) =>
            {
                let msg = res.msg || JSON.stringify(res);
                web.buttons.stopSavingAnimButton();
                if (res.success)
                {
                    const infoEle = ele.byId("hints");
                    if (infoEle)
                    {
                        ele.hide(infoEle);
                    }
                    if (errorEle)
                    {
                        errorEle.classList.remove("error");
                        errorEle.classList.add("info");
                        errorEle.innerText = "Successfully deleted!";
                        ele.show(errorEle);
                    }
                    ele.hide(deleteButton);
                }
                else
                {
                    if (errorEle)
                    {
                        errorEle.innerText = "Failed to delete file: " + msg;
                        ele.show(errorEle);
                    }
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                let msg = res.msg || JSON.stringify(res);
                if (errorEle)
                {
                    errorEle.innerText = "Failed to delete file: " + msg;
                    ele.show(errorEle);
                }
            });
    }
}
